import { Spinner } from '@fluentui/react-components';
import './LoadingSpinner.scss';
import { FlexBox } from './flex-box';

interface LoadingSpinnerProps {
  size?: 'extra-tiny' | 'tiny' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge';
  color?: string;
  label?: string;
  labelPosition?: 'above' | 'below' | 'before' | 'after';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = props => {
  const {
    size,
    color = '#0078d4',
    label,
    labelPosition,
  } = props;

  return (
    <FlexBox
      isFullWidth
      aligns='center'
      content='center'
      className='loading-spinner'
    >
      <Spinner
        color={color}
        label={label}
        labelPosition={labelPosition}
        size={size}
      />
    </FlexBox>
  );
};
